export default __webpack_public_path__ + "static/media/logo.e87e3048.png";